export default {
  filters: {
    toggleDrawer: "filters:toggleFilterDrawer",
    updated: "filters:updated",
  },
  sort: {
    toggleDrawer: "sort:toggleSortDrawer",
    updated: "sort:updated",
  },
  availability: {
    toggleDrawer: "availability:toggleShowMore",
  },
};
